import React from 'react';
import { Eyebrow } from './Eyebrow';
import { PLAN_STEPS } from '../data/landing';
export function SevenDayPlan() {
  return <section className="bg-carbon-2 py-14 md:py-20" aria-labelledby="plan-title" data-id="element-167" data-mp="1xoahglo106fb">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-168" data-mp="2bf6xld0rmv5h">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-169" data-mp="27f53boxd1408">
          <Eyebrow tone="dark" data-id="element-170" data-mp="27foln6qx9ues">Tu punto de partida</Eyebrow>
          <h2 id="plan-title" className="mt-4 text-[26px] leading-[1.15] text-ink-light sm:text-[34px] lg:text-[38px]" data-id="element-171" data-mp="1joiwu2307rsc">
            Un plan sencillo para los próximos 7 días
          </h2>
        </div>

        <ol className="mx-auto mt-8 max-w-[560px] border-l border-white/10 pl-6" data-id="element-172" data-mp="1sra9u6bj2vm3">
          {PLAN_STEPS.map((step, index) => <li key={step} className="relative pb-6 last:pb-0" data-id="element-173" data-mp="3455nfamsawb7" data-mpi={index}>
              <span className="absolute -left-[31px] flex h-2.5 w-2.5 items-center justify-center rounded-full bg-gold ring-4 ring-carbon-2" aria-hidden="true" data-id="element-174" data-mp="343b2hwbij474" />
              <span className="block text-[10px] font-bold tracking-[0.16em] text-gold" data-id="element-175" data-mp="3vs5cy30e8xps">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-1 text-[14px] font-bold text-ink-light md:text-[15px]" data-id="element-176" data-mp="8oqx85cb6763">
                {step}
              </h3>
            </li>)}
        </ol>
      </div>
    </section>;
}